import { vansiteInsuranceForm } from '../util/api';

// ================ Action types ================ //

export const INSURANCE_FORM_REQUEST = 'app/form/INSURANCE_FORM_REQUEST';
export const INSURANCE_FORM_SUCCESS = 'app/form/INSURANCE_FORM_SUCCESS';
export const INSURANCE_FORM_ERROR = 'app/form/INSURANCE_FORM_ERROR';

// ================ Reducer ================ //

/** @type {import('../../types/vansite').VanSite.State.Form} */
const initialState = {
  insuranceFormInProgress: false,
  insuranceFormError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case INSURANCE_FORM_REQUEST:
      return { ...state, insuranceFormInProgress: true };
    case INSURANCE_FORM_SUCCESS:
      return { ...state, insuranceFormInProgress: false };
    case INSURANCE_FORM_ERROR:
      return { ...state, insuranceFormInProgress: false, insuranceFormError: payload };

    default:
      return state;
  }
}

// ================ Selectors ================ //


// ================ Action creators ================ //

export const insuranceFormRequest = () => ({ type: INSURANCE_FORM_REQUEST });
export const insuranceFormSuccess = () => ({ type: INSURANCE_FORM_SUCCESS });
export const insuranceFormError = (error) => ({ type: INSURANCE_FORM_ERROR, payload: error });

// ================ Thunks ================ //

/**
 * @type {(params: { values: any }) => import('../../../types/vansite').AppThunkAction<Promise<boolean>>}
 */
export const sendInsuranceForm = (data) => async (dispatch, getState, sdk) => {
  try {
    dispatch(insuranceFormRequest());
    await vansiteInsuranceForm({ data });
    dispatch(insuranceFormSuccess());
    return true;
  } catch (e) {
    dispatch(insuranceFormError());
  }
};


